import jsPDF from "jspdf";
import "jspdf-autotable";
import { numberWithCommas } from "../helpers/app/numberFormater";
import image from "../../assets/logo/authLogo.png";
import { centrePdfText } from "../helpers/app/pdf";
import dayjs from "dayjs";

const generateTrialBalancePdf = (data, asOfDate) => {
  const doc = new jsPDF();
  doc.setFontSize(10);
  doc.addImage(image, "PNG", 60, 15, 80, 25);
  centrePdfText(
    doc,
    "P.O.BOX 610029, Maracha, Uganda | Adongoro Cell, Maracha Town Council",
    45
  );
  centrePdfText(doc, "Mob: +256 393102379", 60);
  centrePdfText(
    doc,
    "Web: www.amaniinitiative.org | Email: info.amaniinitiative@gmail.com",
    65
  );
  centrePdfText(doc, "AMANI INITIATIVE TRIAL BALANCE", 75);
  doc.text(`As at: ${dayjs(asOfDate).format("DD MMMM YYYY")}`, 14, 85);

  const trialBalance = data?.trialBalance || [];
  const totals = data?.totals || {};

  const pdfColumns = ["Account Name", "Debit (UGX)", "Credit (UGX)", "Balance (UGX)"];
  const pdfRows = [];

  trialBalance.forEach((item) => {
    pdfRows.push([
      item.accountName || "",
      item.debit ? numberWithCommas(item.debit) : "0",
      item.credit ? numberWithCommas(item.credit) : "0",
      item.balance !== undefined ? numberWithCommas(item.balance) : "0",
    ]);
  });

  // Add totals row
  pdfRows.push([
    "TOTAL",
    totals.totalDebit ? numberWithCommas(totals.totalDebit) : "0",
    totals.totalCredit ? numberWithCommas(totals.totalCredit) : "0",
    totals.totalBalance !== undefined ? numberWithCommas(totals.totalBalance) : "0",
  ]);

  doc.autoTable(pdfColumns, pdfRows, { startY: 95 });

  let { finalY } = doc.lastAutoTable;

  // Add balance status
  doc.setFontSize(12);
  doc.text("Balanced:", 14, finalY + 15);
  if (totals.totalDebit === totals.totalCredit) {
    doc.setTextColor(82, 196, 26); // Green
    doc.text("Yes", 50, finalY + 15);
  } else {
    doc.setTextColor(255, 77, 79); // Red
    doc.text("No", 50, finalY + 15);
  }
  doc.setTextColor(0, 0, 0); // Reset to black

  // Add summary
  doc.setFontSize(10);
  doc.text(`Total Debit: UGX ${numberWithCommas(totals.totalDebit || 0)}`, 14, finalY + 25);
  doc.text(`Total Credit: UGX ${numberWithCommas(totals.totalCredit || 0)}`, 14, finalY + 32);
  if (totals.totalBalance !== undefined) {
    doc.text(`Total Balance: UGX ${numberWithCommas(totals.totalBalance)}`, 14, finalY + 39);
  }

  const fileName = `TRIAL_BALANCE_AS_OF_${dayjs(asOfDate).format("YYYY-MM-DD")}.pdf`;
  doc.save(fileName);
};

export default generateTrialBalancePdf;

